

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, VModel} from "vue-property-decorator";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo";
import {IErrors} from "@/model/IErrors";


const orderModule = namespace("orderModule");

@Component({})
export default class CollectByAdministratorDialog extends Vue {
  @VModel()
  private show!: boolean;

  @Prop()
  private orderId!: number;

  @orderModule.Getter('errors')
  private errors!: IErrors;

  @orderModule.Action('collectByAdministrator')
  protected collectByAdministrator!: (param: {orderId: number, collect_reason: string}) => Promise<any>;

  private collectReason: string = '';
  private loading: boolean = false;
  private subscribes: IOnOffHandlers = {};

  private get canSend() {
    return this.collectReason.length >= 10;
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.onClose,
      'backend.call.OK.orderCollectedByAdministrator': this.onBackendOk,
      'backend.call.KO.orderCollectedByAdministrator': this.onBackendKO,
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onBackendOk() {
    this.onClose();
    this.loading = false;
    this.collectReason = '';

  }

  private onBackendKO() {
    this.loading = false;
  }

  private onClose() {
    this.show = false;
  }

  private onSubmit() {
    this.loading = true;
    this.collectByAdministrator({
      orderId: this.orderId,
      collect_reason: this.collectReason,
    })
  }

}
